class StickyBuyBar extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector(this.dataset.target);
    if (!this.target) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const isPastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-buy-bar--visible', isPastButton);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-buy-bar', StickyBuyBar);
